import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/core/state/users/users.service';

@Component({
  selector: 'black-parental-consent',
  templateUrl: './parental-consent.component.html',
  standalone: false,
})
export class ParentalConsentComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);

  isLoading = true;
  isSuccess = false;
  message = '';

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    const action = this.route.snapshot.queryParamMap.get('action');

    if (!token || !action) {
      this.isLoading = false;
      this.isSuccess = false;
      this.message = 'Invalid request. Missing token or action.';
      return;
    }

    this.userService.submitParentalConsent(token, action).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.isSuccess = true;
        this.message = res.message || 'Action completed successfully.';
      },
      error: (err) => {
        this.isLoading = false;
        this.isSuccess = false;
        this.message = err.error?.message || 'An error occurred. The link might be expired or invalid.';
      },
    });
  }
}
